import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Button, Alert } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import SegmentedToggle from '../../components/SegmentedToggle';
import TimeRangeSelect from '../../components/TimeRangeSelect';
import { DASHBOARD_TABS, tabIdFromPathname } from './dashboardTabConfig';
import { DashboardProvider, useDashboard } from './DashboardContext';
import '../Dashboard.css';

function DashboardLayoutInner() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab = tabIdFromPathname(location.pathname);
  const {
    isAdmin,
    showAll,
    setShowAll,
    timeRange,
    setTimeRange,
    fetchError,
    lastFetchedAt,
    load,
  } = useDashboard();

  const showStaleBanner = Boolean(fetchError);

  return (
    <div className="page-container">
      <div className="dashboard-header">
        <div className="dashboard-header-top">
          <div className="page-header dashboard-header-title">
            <h2 className="page-header-title">Dashboard</h2>
            <span className="page-header-subtitle">
              {showAll && isAdmin ? 'Platform-wide statistics and activity' : 'Your personal statistics and activity'}
            </span>
          </div>
          <div className="dashboard-header-toolbar">
            {isAdmin && (
              <div className="dashboard-view-toggle">
                <Button.Group className="view-toggle-group">
                  <Button
                    type={!showAll ? 'primary' : 'default'}
                    onClick={() => setShowAll(false)}
                    className="view-toggle-btn"
                  >
                    Personal
                  </Button>
                  <Button
                    type={showAll ? 'primary' : 'default'}
                    onClick={() => setShowAll(true)}
                    className="view-toggle-btn"
                  >
                    Platform
                  </Button>
                </Button.Group>
              </div>
            )}
            <TimeRangeSelect
              value={timeRange}
              onChange={setTimeRange}
              className="time-range-select__trigger--full-width"
            />
          </div>
        </div>
        <div className="dashboard-tab-nav">
          <SegmentedToggle
            options={DASHBOARD_TABS.map((tab) => ({
              value: tab.id,
              label: tab.label,
            }))}
            value={activeTab}
            onChange={(tabId) => {
              const tab = DASHBOARD_TABS.find((t) => t.id === tabId);
              if (tab) navigate(tab.path);
            }}
          />
        </div>
      </div>

      {showStaleBanner && (
        <Alert
          type="warning"
          showIcon
          className="dashboard-stale-banner"
          message={`Unable to refresh — last updated ${lastFetchedAt ? new Date(lastFetchedAt).toLocaleTimeString() : 'unknown'}`}
          action={(
            <Button size="small" icon={<ReloadOutlined />} onClick={() => load({ force: true })}>
              Retry
            </Button>
          )}
        />
      )}

      <Outlet />
    </div>
  );
}

export default function DashboardLayout() {
  return (
    <DashboardProvider>
      <DashboardLayoutInner />
    </DashboardProvider>
  );
}
